import { RxCornerBottomLeft } from 'react-icons/rx';
import General from 'src/utils/GeneralUtils';
import './DistrictHoverInfo.scss';

interface DistrictHoverInfoProps {
  district: any;
  isLast?: boolean;
  /** How many people match the Navigator's query here; undefined when nothing was searched. */
  matchingPeople?: number;
  /** What a click does to the open beacon here; undefined while no beacon is being edited. */
  editHint?: 'add' | 'remove';
}

const getPercentileClass = (percentile: number) => {
  if (percentile >= 75) return 'percentile-green';
  if (percentile >= 50) return 'percentile-light-green';
  if (percentile >= 25) return 'percentile-orange';
  return 'percentile-red';
};

export default function DistrictHoverInfo({ district, isLast = true, matchingPeople, editHint }: DistrictHoverInfoProps) {
  return (
    <div style={{
      marginBottom: isLast ? '0' : '16px',
      paddingBottom: isLast ? '0' : '16px',
      borderBottom: isLast ? 'none' : '1px solid var(--amplify-colors-neutral-20)'
    }}>
      <div className="districtName">
        {district.name || 'Unknown'}
      </div>

      {editHint && (
        <div className="studentsHeading" style={{ marginTop: '4px', opacity: 0.7 }}>
          {editHint === 'add' ? 'Click to add' : 'Click to remove'}
        </div>
      )}

      {matchingPeople !== undefined && (
        <div className="studentsHeading" style={{ marginTop: '8px' }}>
          {General.addCommasToNumber(matchingPeople)} matching {matchingPeople === 1 ? 'person' : 'people'}
        </div>
      )}

      {/* With a query's counts shown, the name and its matches are the whole story: the size and
          rankings below are for browsing the map, not for reading a result. */}
      {matchingPeople === undefined && (
        <>
        {district.nr_students ? (
          <div className="studentsHeading" style={{ marginTop: '16px' }}>
            {General.addCommasToNumber(district.nr_students) + ' students'}
          </div>
        ) : null}

        {/* Enrollment rankings */}
        {district.enrollmentRankCountry && district.totalDistrictsCountry > 1 && district.enrollmentPercentileCountry != null && (
          <>
            <div className="rankingItem">
              <RxCornerBottomLeft className="rankingIcon" />
              <span>
                <span className={getPercentileClass(district.enrollmentPercentileCountry)}>
                  More than {district.enrollmentPercentileCountry}%
                </span>{' '}
                of districts in the US
              </span>
            </div>
            <div className="rankingItem rankingItemNested">
              <RxCornerBottomLeft className="rankingIcon" />
              <span className="rankingMuted">
                Rank #{General.addCommasToNumber(district.enrollmentRankCountry)} /{' '}
                {General.addCommasToNumber(district.totalDistrictsCountry)} districts in the US
              </span>
            </div>
          </>
        )}

        {district.enrollmentRankState && district.totalDistrictsState > 1 && district.enrollmentPercentileState != null && (
          <>
            <div className="rankingItem">
              <RxCornerBottomLeft className="rankingIcon" />
              <span>
                <span className={getPercentileClass(district.enrollmentPercentileState)}>
                  More than {district.enrollmentPercentileState}%
                </span>{' '}
                of districts in {district.loc_state}
              </span>
            </div>
            <div className="rankingItem rankingItemNested">
              <RxCornerBottomLeft className="rankingIcon" />
              <span className="rankingMuted">
                Rank #{General.addCommasToNumber(district.enrollmentRankState)} /{' '}
                {General.addCommasToNumber(district.totalDistrictsState)} districts in {district.loc_state}
              </span>
            </div>
          </>
        )}
        </>
      )}
    </div>
  );
}
